import { isObjectNotEmpty } from '@/helpers/shadcn/utils'
import {
  PageError404,
  PgcsHome,
  TestPage,
} from '@/pages'
import { PageError403 } from '@/pages/Errors/403'
import { PageError500 } from '@/pages/Errors/500'

import { UserDetails } from '@/services/UserDetails'
import { useAppDispatch } from '@/store'
import { setShellActive, setShellPath } from '@/store/slices/commonSlice'
import { setCountryCode } from '@/store/slices/countryCodeSlice'
import { setUserDetails } from '@/store/slices/userSlice'
import { ROUTES } from '@/utils/constants/routesConstants'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { ProtectedRoutes } from './ProtectedRoutes'

const router = createBrowserRouter([
  {
    element: <ProtectedRoutes />,
    children: [

      { path: ROUTES.HOME, element: <PgcsHome /> },

      /* Errors */
      { path: ROUTES.ERROR_500, element: <PageError500 /> },
      { path: ROUTES.ERROR_403, element: <PageError403 /> },
      { path: '*', element: <PageError404 /> },

      { path: ROUTES.TEST, element: <TestPage /> },

    ],
  },
])

export const AppRouter = ({ shellActive, darkTheme, path, market }) => {

  const dispatch = useAppDispatch()

  const userData = useSelector(state => state?.userDetails)
  const getUserData = async () => {
    if (!isObjectNotEmpty(userData)) {
      try {
        await UserDetails()
        const reqData = {
          name: 'Robert',
          role: ['admin', 'super-admin'],
          country: [{ name: 'Mexico', lang: [{ langcode: 33, name: 'mexico' }] }],
          countryCode: 'mx',
          siteId: 21,
        }
        dispatch(setUserDetails(reqData))
      } catch {
        const reqData = {
          name: 'Louis',
          role: ['admin'],
          country: [{ name: 'Turkey', lang: [{ langcode: 31, name: 'Turkey' }] }],
          countryCode: 'TR',
          siteId: 23,
        }
        dispatch(setUserDetails(reqData))
      }
    }
  }
  useEffect(() => {
    getUserData()
  })
  useEffect(() => {
    dispatch(setShellActive(shellActive))
    if (market) {
      dispatch(setCountryCode(market))
    }
  }, [shellActive, dispatch, market])

  useEffect(() => { }, [darkTheme])

  // expected everytime to dispatch the shell path when component is mounted to navigate properly
  useEffect(() => {
    dispatch(setShellPath(path))
  })

  // Use market as key to force remount (refresh) when market changes
  return (

      <RouterProvider key={market || 'default'} router={router} />
  )
}
